<div
  id="select-company"
  class="select-company-tree"
  tabindex="-1"
  #panelRoot
  (click)="$event.stopPropagation()"
  (keydown.tab)="$event.stopPropagation()"
>
  <div class="company-menu-header">
    @if (treeService.initialStatus() === 'error') {
      <div id="errorBox" class="alert alert-danger tw-mb-2.5" role="alert">
        <strong>{{ treeService.initialErrorMessage() }}</strong>
      </div>
    }
    <search-filter
      [filterConfig]="filterConfig"
      [search]="searchService.search"
      [focus]="true"
      [doSearch]="searchService.doSearch"
    ></search-filter>
  </div>
  <div class="select-company-tree__body" #treeScrollRoot>
    @if (showSpinner()) {
      <div
        id="select-company-list-spinner"
        class="tw-flex tw-justify-center tw-items-center tw-h-32 tw-bg-white/60"
      >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }
    @if (mode() === 'tree' && treeService.initialStatus() === 'loaded') {
      <company-tree
        [scrollRoot]="treeScrollRoot"
        (selectCompany)="closeMenu.emit()"
      ></company-tree>
    }
    @if (mode() === 'search') {
      <company-search-results
        (selectCompany)="closeMenu.emit()"
      ></company-search-results>
    }
    <!-- Mounted rather than wrapped in `@if`: the message replaces the load
         spinner once focus is already in the search field, and a live region
         inserted at that moment is not reliably announced. -->
    <p class="tw-sr-only" role="status">{{ statusMessage() }}</p>
  </div>
  <div class="company-menu-footer">
    <a
      mat-button
      uiSref="apps.company.add"
      id="add-subcompany-menu-button"
      (click)="closeMenu.emit()"
    >
      <div class="tw-flex tw-gap-3 tw-items-center">
        <mat-icon svgIcon="add" class="small medium"></mat-icon>
        <span>Add Sub-Company</span>
      </div>
    </a>
  </div>
</div>
